import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVlcmediaplayerComponent } from './simple-icons-vlcmediaplayer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVlcmediaplayerComponent ],
    exports:      [ SimpleIconsVlcmediaplayerComponent ],
    bootstrap:    []
})
export class SimpleIconsVlcmediaplayerModule {}
